import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "@redux/app-state";
import { isLoadingListState } from "@utils/utils";
import { groupResourcesByCategory } from "../group-resources-by-category";

export const selectDocumentaryResourcesForConsultation = createSelector(
  [(state: AppState) => state.shared.documentaryResourcesRetrieval],
  documentaryResourcesRetrieval => {
    const { data, fetching } = documentaryResourcesRetrieval;

    return {
      groups: groupResourcesByCategory(data),
      isLoading: isLoadingListState(fetching),
    };
  },
);
